import { useDailyEvent } from '@daily-co/daily-react';

type DailyEvent = object & { error?: { msg: string } };

const warn = (msg: string) => (event: DailyEvent) =>
  console.error(`[Daily] ${msg}: ${event?.error?.msg}`, event);

export const useObserveDailyEvents = () => {
  /* Full list of all events: https://docs.daily.co/reference/daily-js/events */

  // Errors
  useDailyEvent('camera-error', warn('Camera Error'));
  useDailyEvent('load-attempt-failed', warn('Load attempt failed'));
  useDailyEvent('error', warn('Generic Error'));
  useDailyEvent('nonfatal-error', warn('Camera Error'));
};
